"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */

var OutputFormat;

(function (OutputFormat) {
  /**
   * @member OutputFormat.Simple
   */
  OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
  /**
   * @member OutputFormat.Detailed
   */

  OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})(OutputFormat = exports.OutputFormat || (exports.OutputFormat = {}));